import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Wrapper from "./App/components/Wrapper/Wrapper";
import Login from "./App/Layout/Auth/Login";
import Userlogin from "./App/Layout/Auth/Userlogin";
import Signup from "./App/Layout/Auth/Signup";
import Forgetpassword from "./App/Layout/Auth/Forgetpassword";
import Forgetpassworduser from "./App/Layout/Auth/Forgetpassworduser";

import 'bootstrap/dist/css/bootstrap.min.css';
import NotificationListener from "./Utils/Notificationalert";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Notfound from "./App/Routes/NotFound"

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const Token = localStorage.getItem("token");
  const Role = localStorage.getItem("Role");

  useEffect(() => {
    if (!Token) {
      if (location.pathname === "/register") {
        navigate("/register");
        return;
      }

      if (location.pathname === "/forget") {
        navigate("/forget");
        return;
      }

      if (location.pathname === "/forget-user") {
        navigate("/forget-user");
        return;
      }
      if (location.pathname === "/notfound") {
        navigate("/notfound");
        return;
      }

      if (
        !location.pathname.includes("login") &&
        !location.pathname.includes("user-login")
      ) {
        navigate("/notfound", { replace: true });
      }
      return;
    }
    if (
      location.pathname === "/forget" ||
      location.pathname.startsWith("/signup")
    ) {
      navigate(location.pathname);
      return;
    }
    if (
      location.pathname.includes("login") ||
      location.pathname.includes("user-login") ||
      location.pathname.includes("notfound") ||
      location.pathname === "/"
    ) {
      switch (Role) {
        case "SUPERADMIN":
          navigate("/superadmin/company");
          break;
        case "ADMIN":
          navigate("/admin/dashboard");
          break;
        case "USER":
          navigate("/user/dashboard");
          break;
        case "EMPLOYEE":
          navigate("/employee/dashboard");
          break;
        default:
          navigate("/user-login", { replace: true });
      }
    }
  }, [Token, Role, location.pathname, navigate]);

  return (
    <>
      <NotificationListener />
      <ToastContainer />
      <div className="App">
        {!(location.pathname === "/register" ||
          location.pathname === "/login" ||
          location.pathname === "/forget" ||
          location.pathname === "/forget-user" ||
          location.pathname === "/notfound" ||
          location.pathname === "/user-login") && (


            Token && Role ? (
              <Wrapper />
            ) : (
              navigate("/notfound", { replace: true })
            )
          )}

        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/user-login" element={<Userlogin />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/forget" element={<Forgetpassword />} />
          <Route path="/forget-user" element={<Forgetpassworduser />} />
          {/* <Route path="/signup/*" element={<div>Signup Page</div>} /> */}
          <Route path="/notfound" element={<div><Notfound /></div>} />


        </Routes>
      </div>
    </>
  );
};

export default App;
